import { useState, useEffect, useContext, useCallback } from 'react';
import { JobDescription } from '../Entities/job-description.entity';
import JobDescriptionService from '../Services/job-description.service';
import LoaderContext from '../Context/LoaderContext/Index';
import { findAllJobPostDto, Pagination, PositionWithOpeningCount } from '../Interface/Index';

export const useJobDescription = (filters: findAllJobPostDto) => {
    const [jobDescriptions, setJobDescriptions] = useState<JobDescription[]>([]);
    const [positionsWithOpeningCount, setPositionsWithOpeningCount] = useState<PositionWithOpeningCount[]>([]);
    const { setLoading, setLoadingMessage } = useContext(LoaderContext);
    const [pagination, setPagination] = useState<Pagination>({
        total: 0,
        page: 1,
        limit: 10,
        totalPages: 0
    });

    const jobDescriptionService = new JobDescriptionService();

    const fetchJobDescriptions = useCallback(async () => {
        try {
            setLoading(true);
            setLoadingMessage('Fetching job descriptions...');

            const result = await jobDescriptionService.findAllJobPostWithFiletrsAndPositionCounts(
                filters
            );

            const { jobPosts, positionsWithOpeningCount, pagination } = result;
            setJobDescriptions(jobPosts);
            setPositionsWithOpeningCount(positionsWithOpeningCount);
            setPagination(pagination);
        } catch (err) {
            console.error('Failed to fetch job descriptions:', err);
            setJobDescriptions([]);
            setPositionsWithOpeningCount([]);
            setPagination({
                total: 0,
                page: 1,
                limit: 10,
                totalPages: 0
            });
        } finally {
            setLoading(false);
            setLoadingMessage(null);
        }
    }, [filters, jobDescriptionService, setLoading, setLoadingMessage]);

    useEffect(() => {
        fetchJobDescriptions();
    }, [filters]);

    return {
        jobDescriptions,
        positionsWithOpeningCount,
        pagination,
        refetch: fetchJobDescriptions
    };
};
